import { render } from "./InspectionForm.vue?vue&type=template&id=0905ffa2&scoped=true"
import script from "./InspectionForm.vue?vue&type=script&lang=js"
export * from "./InspectionForm.vue?vue&type=script&lang=js"

import "./InspectionForm.vue?vue&type=style&index=0&id=0905ffa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0905ffa2"]])

export default __exports__